<template>
  <div>
    <tables :config="config()" />
  </div>
</template>

<script>
  import { get, post, put, destroy } from "@/service/Axios";
  export default {
    data () {
      return {
        list: [],
        sub_list: []
      }
    },
    components: {
      tables: () => import(/* webpackPrefetch: true */ '@/components/basic/table.vue')
    },
    computed: {
      user () {
        return this.$store.state.user
      },
      set_filter () {
        return this.$store.state.filter
      },
      hak_akses () {
        let menu = {}
        // console.log(this.$store.state.menu)
        this.$store.state.menu.map(item => {
          if (item.id === 4) {
            menu = item
          }
        })
        return menu
      },
    },
    watch: {
    },
    mounted () {
      this.fetch()
    },
    methods: {
      async fetch () {
        let params = {
          // parent_id: 3
        }

        this.list = []

        await get('admin/unit', { params })
        .then(response => {
          let res = response.data

          if (res.status === 200) {
            let data = res.results.data

            data.map((obj) => {
              if (parseInt(obj.parent_id) === 0 || parseInt(obj.parent_id) === 1 || parseInt(obj.parent_id) === 3) {
                this.list.push({
                  text: obj.name,
                  value: obj.id
                })
              }
            })

            this.list.reverse()

            this.fetchSub()
          }
        })
      },
      async fetchSub () {
        let params = {
          // parent_id: this.form.unit
        }

        await get('admin/unit', { params })
        .then(response => {
          let res = response.data

          if (res.status === 200) {
            let data = res.results.data

            data.map((obj) => {
              this.sub_list.push({
                text: obj.name,
                value: obj.id
              })
            })
          }
        })
      },
      
      objectFine () {
        let self = this

        let data = this.set_filter.filter(function(v) {
          return self.$route.fullPath == v.path
        })

        return data.length > 0 ? data[0] : []
      },

      config () {
        return {
          // CONFIG PARSING API
          api: 'admin/user',

          // SINGLE
          single: true,

          // CHECKBOX
          checkbox: false,

          // PADDING
          padding: 'py-0',

          // HEIGHT
          height: true,

          // SHADOW
          shadow: true,

          // CONFIG PARSING HEADER
          header: [
            {
              text: '#No',
              width: '75px',
              value: 'index',
              sortable: false,
              freeze: true,
              hide: false,
              align: 'center'
            },
            {
              text: 'Nama Lengkap',
              width: '400px',
              value: 'name',
              freeze: false,
              hide: false
            },
            {
              text: 'Kalenggahan',
              width: '200px',
              value: 'kalenggahan',
              freeze: false,
              hide: false
            },
            {
              text: 'Nama Kalenggahan',
              width: '200px',
              value: 'kalenggahan_name',
              freeze: false,
              hide: false
            },
            {
              text: 'Nomor Induk Kependudukan',
              width: '250px',
              value: 'code',
              freeze: false,
              hide: false
            },
            {
              text: 'Telepon',
              width: '200px',
              value: 'mobilephone',
              freeze: false,
              hide: false
            },
            {
              text: 'Alamat Domisili',
              width: '400px',
              value: 'domicile_address',
              freeze: false,
              hide: false
            },
            {
              text: 'Kawedanan',
              width: '300px',
              value: 'kawedanan',
              freeze: false,
              hide: false
            },
            {
              text: 'Urusan',
              width: '300px',
              value: 'seksi',
              freeze: false,
              hide: false
            },
            {
              text: 'Kategori',
              width: '200px',
              value: 'category',
              freeze: false,
              hide: false
            },
            {
              text: 'Role',
              width: '200px',
              value: 'role',
              freeze: false,
              hide: false
            },
            {
              text: 'Status',
              width: '200px',
              value: 'status',
              freeze: false,
              hide: false
            },
            {
              text: 'Status User',
              width: '200px',
              value: 'is_active',
              freeze: false,
              hide: false
            }
          ],

          // CONFIG PARSING FILTER
          filter: [
            {
              field: 'unit_id',
              label: 'Kawedanan',
              type: 'select',
              placeholder: 'Contoh. TEPAS KAPRANITAN',
              value: this.set_filter.length > 0 && Object.keys(this.objectFine()).length > 0 ? this.objectFine().unit_id : '',
              option: this.list,
              width: '100%',
              required: false
            },
            {
              field: 'urusan_id',
              label: 'Urusan',
              type: 'select',
              placeholder: 'Contoh. SEKSI LANGENPRAJA',
              value: this.set_filter.length > 0 && Object.keys(this.objectFine()).length > 0 ? this.objectFine().urusan_id : '',
              option: this.sub_list,
              width: '100%',
              required: false
            },
            {
              field: 'is_active',
              label: 'Status User',
              type: 'select',
              placeholder: 'Contoh. AKTIF',
              value: this.set_filter.length > 0 && Object.keys(this.objectFine()).length > 0 ? this.objectFine().is_active : '',
              option: [
                {
                  text: 'SEMUA',
                  value: ''
                },
                {
                  text: 'AKTIF',
                  value: 'AKTIF'
                },
                {
                  text: 'TIDAK AKTIF',
                  value: 'TIDAK AKTIF'
                }
              ],
              width: '100%',
              required: false
            },
            {
              field: 'is_terima_danais',
              label: 'Bantuan Penghasilan / Danais',
              type: 'select',
              placeholder: 'Contoh. YA',
              value: this.set_filter.length > 0 && Object.keys(this.objectFine()).length > 0 ? this.objectFine().is_terima_danais : '',
              option: [
                {
                  text: 'SEMUA',
                  value: ''
                },
                {
                  text: 'YA',
                  value: '1'
                },
                {
                  text: 'TIDAK',
                  value: '0'
                }
              ],
              width: '100%',
              required: false
            },
            {
              field: 'is_anggota_koperasi',
              label: 'Anggota Koperasi',
              type: 'select',
              placeholder: 'Contoh. YA',
              value: this.set_filter.length > 0 && Object.keys(this.objectFine()).length > 0 ? this.objectFine().is_anggota_koperasi : '',
              option: [
                {
                  text: 'SEMUA',
                  value: ''
                },
                {
                  text: 'YA',
                  value: '1'
                },
                {
                  text: 'TIDAK',
                  value: '0'
                }
              ],
              width: '100%',
              required: false
            }
          ],

          // PREFIX KEY
          prefix: '',

          // CONFIG PARSING FORM
          form: [],

          // CONFIG PARSING ACTION
          action: {
            tab: {
              button: false,
              api: [],
              field: ''
            },
            filter: {
              button: true,
              api: ''
            },
            add: {
              button: this.hak_akses.action.add === true ? true : false,
              api: '',
              window: true,
              href: '/sentana/form/add?step=1'
            },
            edit: {
              button: this.hak_akses.action.update === true ? true : false,
              api: '',
              window: true,
              href: '/sentana/form/edit',
              query: '?step=1'
            },
            delete: {
              button: this.hak_akses.action.delete === true ? true : false,
              api: 'admin/user/delete'
            },
            detail: {
              button: this.hak_akses.action.detail ? true : false,
              api: '/sentana/'
            },
            attachment: {
              button: false,
              api: ''
            },
            active: {
              button: this.hak_akses.action.aktif === true ? true : false,
              api: 'admin/user/activate'
            },
            deactive: {
              button: this.hak_akses.action.aktif === true ? true : false,
              api: 'admin/user/deactivate',
              form: {
                id: '',
                is_active_desc: '',
                is_active_url: ''
              }
            },
            reject: {
              button: false,
              api: ''
            },
            approve: {
              button: false,
              api: ''
            },
            print: {
              button: this.hak_akses.action.export ? true : false,
              api: 'admin/user/export'
            },
            freeze: {
              button: true,
              api: ''
            },
            hide: {
              button: true,
              api: ''
            }
          }
        }
      }
    }
  }
</script>